import React from 'react';
import { useState } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import br from 'date-fns/locale/pt-BR';
registerLocale('br', br);

function DateTimeField(props) {
    let dateTimeValue = '';

    if (props.value && props.value !== '') {
        dateTimeValue = moment(props.value).toDate();
    }

    let [value, updateValue] = useState(dateTimeValue);
    let className = 'form-control';

    const handleChange = (element) => {
        const target = {
            name: props.name,
            type: 'datetime', 
            value: moment(element).format('YYYY-MM-DD HH:mm:ss'),
        };
        
        console.log(element);
        console.log(target);

        updateValue(element);
        props.onChange({ target: target });
    };

    if (props.error) {
        className += ' is-invalid';
    }

    return (
        <div>
            {!props.readOnly && (
                <div>
                    <DatePicker
                        id={'id_' + props.name}
                        name={props.name}
                        selected={value}
                        onChange={handleChange}
                        locale="br"
                        dateFormat="dd/MM/yyyy HH:mm" 
                        showTimeSelect
                        timeIntervals={15}
                        timeCaption="Time"
                        timeFormat="HH:mm"
                        strictParsing
                        className={className}
                        autoFocus={props.autoFocus ? true : false}
                    />
                </div>
            )}

            {props.readOnly && (
                <span>{moment(value).format('DD/MM/YYYY HH:mm')}</span>
            )}

            {props.error && (
                <span
                    className="error invalid-feedback"
                    style={{ display: 'inline' }}
                >
                    {props.error}
                </span>
            )}
        </div>
    );
}

export default DateTimeField;
